import { RealEstateDTO } from '../../tables/RealEstate/RealEstate.meta';
import { BusinessAssetDTO } from '../../tables/Business/Business.meta';
import { PensionDTO } from '../../tables/Pensions/Pensions.meta';
import { MiscAssetDTO } from '../../tables/MiscAssets/MiscAssets.meta';
import { DeferredCompensationDTO } from '../../tables/DeferredCompensation/DeferredCompensation.meta';
import { ASSET_NAME_MAP, OtherAssetType } from '../../OtherAssets.meta';
import { OptionType } from '../../../../CommonComponents/OPL/Select/BaseSelect/types';

export type AssetToUpsert =
  | RealEstateDTO
  | BusinessAssetDTO
  | PensionDTO
  | MiscAssetDTO
  | DeferredCompensationDTO
  | {
      Id?: string;
      OtherAssetType?: OtherAssetType;
      Name?: string;
      isClone?: boolean;
    };

export const UPSERT_ASSET_FORM_ID = 'other-assets--upsert-asset--form';

export const UPSERT_ASSET_MK = 'upsertOtherAssetMutation';

export const OTHER_ASSETS_OPTIONS: OptionType<OtherAssetType>[] = [
  { value: OtherAssetType.RealEstate, label: ASSET_NAME_MAP[OtherAssetType.RealEstate] },
  { value: OtherAssetType.Business, label: ASSET_NAME_MAP[OtherAssetType.Business] },
  { value: OtherAssetType.Pension, label: ASSET_NAME_MAP[OtherAssetType.Pension] },
  {
    value: OtherAssetType.Miscellaneous,
    label: ASSET_NAME_MAP[OtherAssetType.Miscellaneous],
    subLabel: 'Car, jewelry, art, etc.',
  },
  {
    value: OtherAssetType.DeferredCompensation,
    label: ASSET_NAME_MAP[OtherAssetType.DeferredCompensation],
  },
];
